import { render, staticRenderFns } from "./FbaBarcode.vue?vue&type=template&id=36214b60&"
import script from "./FbaBarcode.vue?vue&type=script&lang=js&"
export * from "./FbaBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports